import { pageConfig } from "@/common/service/page-config";
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
const ComparisonTypeMap = {
  FEATURES: 'features',
  EVENT_ATTRIBUTES: 'eventAttributes',
  HUB_COLLABORATION: 'hubCollaboration',
  EVENT_SETUP: 'eventSetup',
  PRODUCTION_TOOLS: 'productionTools',
  AUDIENCE_ENGAGEMENT: 'audienceEngagement',
  ANALYTICS: 'analytics',
  PAYMENTS_BILLING: 'paymentsBilling',
  POST_EVENT_FEATURES: 'postEventFeatures',
  INTEGRATIONS: 'Integrations',
  ADDITIONAL_FEATURES: 'additionalFeatures',
};

const webinarsNewFeatureItem = pageConfig.webinarsNewFeatureItem;

export default {
  data() {
    return {
      tableData: {
        features: [
          {
            feature: `${this.$t('zoomOneRequired')}`,
            tooltip: this.$t('zoomOneAddOnRequired'),
            mixed: true,
            webinar: `${this.$t('billing.comparison.required_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('sessionTypeOptions'),
            isString: true,
            webinar: `${this.$t('events.webinarTitle')}`,
            sessions: `${this.$t('webinarOrMeeting')}`,
            events: `${this.$t('webinarOrMeeting')}`,
          },
          {
            feature: 'Single-Session Events',
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: 'Multi-Session Events',
            tooltip: this.$t('multiDayMultiTrackConcurrentSessions'),
            events: true,
          },
          {
            feature: this.$t('teamCollaboration'),
            tooltip: this.$t(
              'licensesOf_500CapacityAndAboveComeWith_5HubHostsAnd_3CoEditorsAndThe_100CapacityLicensesComeWith_2HubHostsAnd_1CoEditorEachOfThese_5HostsCanCollaborateOnEachOthersEventsIncludingHostingSessionsEditingAndUpdatingEventContentCreatingAndPushingEventsLiveAndAssigningRolesWithinAnEventAdditionalHostsAndCoEditorsCanBePurchasedFor_75PerHostOrCoEditorPerMonthForZoomEventsAnd_65PerHostOrCoEditorPerMonthForZoomSessions',
            ),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('eventOrSessionBranding'),
            tooltip: this.$t(
              'inZoomEventsAndZoomSessionsEventHostsCanCreateAUniqueColorPaletteAndApplyBrandingAcrossTheEntireEventIncludingAttendeeEmailsInZoomWebinarsEventHostsCanApplyNameTagsUploadABacksplashAndIncludeUniformVirtualBackgroundsForEachSpeaker',
            ),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('productionTools'),
            tooltip: this.$t(
              'useBackstageSimuliveAndLaunchInSessionResourcesAndCtasThroughoutYourEventToKeepYourTeamOrganizedAndYourAttendeesEngaged',
            ),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('expoAndSponsors'),
            tooltip: this.$t('highlightYourSponsorsAndKeepYourAttendeesEngagedWithTheVirtualExpoHall'),
            events: true,
          },
          {
            feature: this.$t('events.eventsProductFeature3'),
            tooltip: this.$t('eventHubsThatAllowYouToOrganizeYourEventsAndPostEventRecordings'),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('eventAnalyticsAndReporting'),
            tooltip: this.$t('eventAnalyticsToTrackRevenueEngagementAndAttendanceForAllOfYourEvents'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('interactiveInSessionFeatures'),
            tooltip: this.$t('inSessionQAndAChatPollingAndQuizzes'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: `*${this.$t('billing.comparison.footer_desc.feature')}`,
            footerDesc: true,
            subTitle: true,
            required: true,
          },
        ],
        eventAttributes: [
          {
            feature: this.$t('durationPerSession'),
            isString: true,
            webinar: `${this.$t('billing.comparison.30_hours')}*`,
            sessions: '30 hours',
            events: '30 hours',
          },
          {
            feature: this.$t('100InteractiveVideoPanelists_49ViewableOnScreenAtOneTime'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('eventRegistration'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('eventManagementPlatformEventInformationSpeakerListRegistration'),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('sessionBranding'),
            tooltip: this.$t('setMatching'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('eventBranding'),
            tooltip: this.$t('customizeRegistration'),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('speakerBioInformation'),
            webinar: 'On Registration Page',
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('sessionVideoPreviews'),
            events: true,
          },
          {
            feature: this.$t('streamingSessionsInEventLobby'),
            tooltip: this.$t(
              'giveYourAttendeesAWayToPreviewConcurrentSessionsThatAreTakingPlaceByScrollingThroughTheLiveSessionsWithinTheEventLobby',
            ),
            events: true,
          },
          {
            feature: this.$t('eventSponsors'),
            events: true,
          },
          {
            feature: this.$t('expoFloor'),
            tooltip: this.$t(
              'expoFloorForAttendeesToInteractWithSponsorsEngageInLiveConversationsAndExploreExpoBooths',
            ),
            events: true,
          },
          {
            feature: `*${this.$t('billing.comparison.footer_desc.event_attributes')}`,
            footerDesc: true,
            subTitle: true,
            required: true,
          }
        ],
        hubCollaboration: [
          {
            feature: this.$t('associatedWithAnEventHubPerLicense'),
            tooltip: this.$t('eventHubsThatAllowYouToOrganizeYourEventsAndPostEventRecordings'),
            sessions: true,
            events: true,
          },
        ],
        eventSetup: [
          {
            feature: this.$t('customizablePreAndPostEventEmailReminders'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('customizableRegistration'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: `${this.$t('ticketing')}<br>(${this.$t('paidFree')})`,
            isString: true,
            webinar: 'Basic',
            sessions: '<i tabindex="-1" class="zm-icon-ok" :aria-label="zm-icon-ok"></i>',
            events: '<i tabindex="-1" class="zm-icon-ok" :aria-label="zm-icon-ok"></i>',
          },
        ],
        productionTools: [
          {
            feature: this.$t('practiceSession'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('productionStudio'),
            tooltip: this.$t(
              'avoidAdditionalProductionAndAgencyCostsByDesigningYourOwnInSessionLayoutsCreateMultipleWebinarScenesWithCustomLayoutsAndDetermineTheirSequenceCustomizeVideoBordersChangeAspectRatiosAndAddSceneWallpapers',
            ),
            sessions: true,
            events: true,
            needClose: webinarsNewFeatureItem ? 'no' : 'yes',
          },
          {
            feature: this.$t('1080pVideoResolution'),
            sessions: true,
            events: true,
            needClose: webinarsNewFeatureItem ? 'no' : 'yes',
          },
          {
            feature: this.$t('backstage'),
            tooltip: this.$t(
              'aBehindTheScenesEventManagementSpaceForTheProductionCrewAndPanelistsToCollaborateBeforeDuringAndAfterASessionThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense',
            ),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('simulive'),
            tooltip: this.$t(
              'provideEngagingContentAtAnyTimeOfTheDayInAnyTimeZoneSimuliveWillBringTheLiveExperienceToAllAttendeesWithPreRecordedContentThatStartsAndEndsAutomaticallyThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense',
            ),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('sessionResources'),
            tooltip: this.$t(
              'allowAttendeesToViewAndDownloadDocumentsDuringTheSessionThroughCustomizableCallsToActionWithinAWebinarSessionThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense',
            ),
            sessions: true,
            events: true,
          },
        ].filter(x => x.needClose !== 'yes'),
        audienceEngagement: [
          {
            feature: 'Session Chat',
            mixed: true,
            webinar: `${this.$t('billing.comparison.include_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('lobbyChat'),
            events: true,
          },
          {
            feature: this.$t('livePollingAndResults'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('qAndA'),
            mixed: true,
            webinar: `${this.$t('billing.comparison.include_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('sessionSurveys'),
            mixed: true,
            webinar: `${this.$t('billing.comparison.include_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('eventSurveys'),
            events: true,
          },
          {
            feature: this.$t('liveTranscription'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('languageInterpreterSupport'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('cloudRecordingsAndTextTranscripts'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: `*${this.$t('billing.comparison.included_in_zoom_webinars_attendees')} ${this.$t('billing.comparison.footer_desc.audience_engagement')}`,
            footerDesc: true,
            subTitle: true,
            required: true,
          }
        ],
        analytics: [
          {
            feature: this.$t('performanceAndAudienceEngagementReports'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('detailedAnalyticsDashboardsAndReporting'),
            sessions: true,
            events: true,
          },
        ],
        paymentsBilling: [
          {
            feature: this.$t('billingManagementAccountLevelAndHubLevel'),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('paymentProviderStripe'),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('paymentProviderPaypal'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('taxation'),
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('taxComplianceControlForEu'),
            sessions: true,
            events: true,
          },
        ],
        postEventFeatures: [
          {
            feature: this.$t('recordingCloudLocal'),
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: `${this.$t('onDemandRecordingAvailable')}<br>${this.$t('postEvent')}`,
            webinar: true,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('postEventSurvey'),
            sessions: true,
            events: true,
          },
        ],
        Integrations: [
          {
            feature: this.$t('eloquaIntegration'),
            mixed: true,
            webinar: `${this.$t('billing.comparison.include_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: 'HubSpot Integration',
            mixed: true,
            webinar: `${this.$t('billing.comparison.include_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('marketoIntegration'),
            mixed: true,
            webinar: `${this.$t('billing.comparison.include_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: this.$t('pardotIntegration'),
            mixed: true,
            webinar: `${this.$t('billing.comparison.include_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: 'Salesforce Integration',
            mixed: true,
            webinar: `${this.$t('billing.comparison.include_in_most_plans')}*`,
            sessions: true,
            events: true,
          },
          {
            feature: `*${this.$t('billing.comparison.included_in_zoom_webinars_attendees')} ${this.$t('billing.comparison.footer_desc.integration')}`,
            footerDesc: true,
            subTitle: true,
            required: true,
          }
        ],
        additionalFeatures: [
          {
            feature: this.$t('attendeeNetworking'),
            isString: true,
            webinar: `${this.$t('billing.comparison.in_webinar_chat_only')}*`,
            sessions: this.$t('inSessionChatOnly'),
            events: this.$t('networkingFeaturesIncludingAttendeeProfileCreation_1_1ChatAndMore'),
          },
          {
            feature: this.$t('professionalServicesAvailable'),
            // tooltip: this.$t('3hoursPPA'),
            isString: true,
            webinar: `${this.$t('asAnAddOn')}*`,
            sessions: this.$t('asAnAddOn'),
            events: this.$t('asAnAddOn'),
          },
          {
            feature: this.$t('localizationToAllZoomLanguages'),
            webinar: true,
          },
          {
            feature: [`*${this.$t('billing.comparison.footer_desc.integration')}`, `*${this.$t('billing.comparison.footer_desc.additional_features')}`],
            footerDesc: true,
            subTitle: true,
            required: true,
          },
        ],
      },
    };
  },
  mounted () {
    if (this.tableData.features?.[0] && this.currentProAnnualPrice?.amount) {
      this.tableData.features[0].feature = `${this.$t('zoomOneRequired')}<br>(${this.$money(this.currentProAnnualPrice.amount)}${this.$t('billing.common.per_billing_cycle_license.annual')})`;
    }
  },
  computed: {
    ...mapGetters(['planMapFlat']),
    currentProAnnualPrice() {
      const proAnnualPlanMap = plansof(this.planMapFlat).category(ZOOM_MEETING_SUB_TYPES.PRO).annual();
      if(proAnnualPlanMap.clone().has(1)) {
        return proAnnualPlanMap.get(0);
      }
      return undefined;
    },
    treeData() {
      const mapItemKey = (data, pid) =>
        data.map((item, idx) => ({
          ...item,
          id: `${pid}_${idx}`,
        }));
      return [
        {
          feature: this.$t('billing.events.plan_details.core_features'),
          id: ComparisonTypeMap.FEATURES,
          subTitle: true,
          children: mapItemKey(this.tableData.features || [], ComparisonTypeMap.FEATURES),
        },
        {
          feature: this.$t('eventAttributes'),
          id: ComparisonTypeMap.EVENT_ATTRIBUTES,
          subTitle: true,
          children: mapItemKey(this.tableData.eventAttributes || [], ComparisonTypeMap.EVENT_ATTRIBUTES),
        },
        {
          feature: this.$t('hubCollaboration'),
          id: ComparisonTypeMap.HUB_COLLABORATION,
          subTitle: true,
          children: mapItemKey(this.tableData.hubCollaboration || [], ComparisonTypeMap.HUB_COLLABORATION),
        },
        {
          feature: this.$t('eventSetup'),
          id: ComparisonTypeMap.EVENT_SETUP,
          subTitle: true,
          children: mapItemKey(this.tableData.eventSetup || [], ComparisonTypeMap.EVENT_SETUP),
        },
        {
          feature: this.$t('productionTools'),
          id: ComparisonTypeMap.PRODUCTION_TOOLS,
          subTitle: true,
          children: mapItemKey(this.tableData.productionTools || [], ComparisonTypeMap.PRODUCTION_TOOLS),
        },
        {
          feature: this.$t('audienceEngagement'),
          id: ComparisonTypeMap.AUDIENCE_ENGAGEMENT,
          subTitle: true,
          children: mapItemKey(this.tableData.audienceEngagement || [], ComparisonTypeMap.AUDIENCE_ENGAGEMENT),
        },
        {
          feature: this.$t('analytics'),
          id: ComparisonTypeMap.ANALYTICS,
          subTitle: true,
          children: mapItemKey(this.tableData.analytics || [], ComparisonTypeMap.ANALYTICS),
        },
        {
          feature: this.$t('paymentsBilling'),
          id: ComparisonTypeMap.PAYMENTS_BILLING,
          subTitle: true,
          children: mapItemKey(this.tableData.paymentsBilling || [], ComparisonTypeMap.PAYMENTS_BILLING),
        },
        {
          feature: this.$t('postEventFeatures'),
          id: ComparisonTypeMap.POST_EVENT_FEATURES,
          subTitle: true,
          children: mapItemKey(this.tableData.postEventFeatures || [], ComparisonTypeMap.POST_EVENT_FEATURES),
        },
        {
          feature: this.$t('events.fullPlanItem14'),
          id: ComparisonTypeMap.INTEGRATIONS,
          subTitle: true,
          children: mapItemKey(this.tableData.Integrations || [], ComparisonTypeMap.INTEGRATIONS),
        },
        {
          feature: this.$t('additionalFeatures'),
          id: ComparisonTypeMap.ADDITIONAL_FEATURES,
          subTitle: true,
          children: mapItemKey(this.tableData.additionalFeatures || [], ComparisonTypeMap.ADDITIONAL_FEATURES),
        },
      ];
    },
  },
};
